export const TIMEZONE_LIST = [
  {
    "name": "Andorra",
    "zone": "Europe/Andorra",
    "timezone": "+01:00",
    "countryIndex": 6,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "United Arab Emirates",
    "zone": "Asia/Dubai",
    "timezone": "+04:00",
    "countryIndex": 232,
    "dsts": "<+04>-4"
  },
  {
    "name": "Afghanistan",
    "zone": "Asia/Kabul",
    "timezone": "+04:30",
    "countryIndex": 1,
    "dsts": "<+0430>-4:30"
  },
  {
    "name": "Antigua and Barbuda",
    "zone": "America/Antigua",
    "timezone": "-04:00",
    "countryIndex": 10,
    "dsts": "AST4"
  },
  {
    "name": "Anguilla",
    "zone": "America/Anguilla",
    "timezone": "-04:00",
    "countryIndex": 8,
    "dsts": "AST4"
  },
  {
    "name": "Albania",
    "zone": "Europe/Tirane",
    "timezone": "+01:00",
    "countryIndex": 3,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Armenia",
    "zone": "Asia/Yerevan",
    "timezone": "+04:00",
    "countryIndex": 12,
    "dsts": "<+04>-4"
  },
  {
    "name": "Angola",
    "zone": "Africa/Luanda",
    "timezone": "+01:00",
    "countryIndex": 7,
    "dsts": "WAT-1"
  },
  {
    "name": "Antarctica",
    "zone": "Antarctica/McMurdo",
    "timezone": "+12:00",
    "countryIndex": 9,
    "dsts": "NZST-12NZDT,M9.5.0,M4.1.0/3"
  },
  {
    "name": "Antarctica",
    "zone": "Antarctica/Casey",
    "timezone": "+08:00",
    "countryIndex": 9,
    "dsts": "<+08>-8"
  },
  {
    "name": "Antarctica",
    "zone": "Antarctica/Davis",
    "timezone": "+07:00",
    "countryIndex": 9,
    "dsts": "<+07>-7"
  },
  {
    "name": "Antarctica",
    "zone": "Antarctica/DumontDUrville",
    "timezone": "+10:00",
    "countryIndex": 9,
    "dsts": "<+10>-10"
  },
  {
    "name": "Antarctica",
    "zone": "Antarctica/Mawson",
    "timezone": "+05:00",
    "countryIndex": 9,
    "dsts": "<+05>-5"
  },
  {
    "name": "Antarctica",
    "zone": "Antarctica/Palmer",
    "timezone": "-03:00",
    "countryIndex": 9,
    "dsts": "<-03>3"
  },
  {
    "name": "Antarctica",
    "zone": "Antarctica/Rothera",
    "timezone": "-03:00",
    "countryIndex": 9,
    "dsts": "<-03>3"
  },
  {
    "name": "Antarctica",
    "zone": "Antarctica/Syowa",
    "timezone": "+03:00",
    "countryIndex": 9,
    "dsts": "<+03>-3"
  },
  {
    "name": "Antarctica",
    "zone": "Antarctica/Troll",
    "timezone": "+00:00",
    "countryIndex": 9,
    "dsts": "<+00>0<+02>-2,M3.5.0/1,M10.3.0/3"
  },
  {
    "name": "Antarctica",
    "zone": "Antarctica/Vostok",
    "timezone": "+05:00",
    "countryIndex": 9,
    "dsts": "<+05>-5"
  },
  {
    "name": "Argentina",
    "zone": "America/Argentina/Buenos_Aires",
    "timezone": "-03:00",
    "countryIndex": 11,
    "dsts": "<-03>3"
  },
  {
    "name": "Argentina",
    "zone": "America/Argentina/Cordoba",
    "timezone": "-03:00",
    "countryIndex": 11,
    "dsts": "<-03>3"
  },
  {
    "name": "Argentina",
    "zone": "America/Argentina/Salta",
    "timezone": "-03:00",
    "countryIndex": 11,
    "dsts": "<-03>3"
  },
  {
    "name": "Argentina",
    "zone": "America/Argentina/Jujuy",
    "timezone": "-03:00",
    "countryIndex": 11,
    "dsts": "<-03>3"
  },
  {
    "name": "Argentina",
    "zone": "America/Argentina/Tucuman",
    "timezone": "-03:00",
    "countryIndex": 11,
    "dsts": "<-03>3"
  },
  {
    "name": "Argentina",
    "zone": "America/Argentina/Catamarca",
    "timezone": "-03:00",
    "countryIndex": 11,
    "dsts": "<-03>3"
  },
  {
    "name": "Argentina",
    "zone": "America/Argentina/La_Rioja",
    "timezone": "-03:00",
    "countryIndex": 11,
    "dsts": "<-03>3"
  },
  {
    "name": "Argentina",
    "zone": "America/Argentina/San_Juan",
    "timezone": "-03:00",
    "countryIndex": 11,
    "dsts": "<-03>3"
  },
  {
    "name": "Argentina",
    "zone": "America/Argentina/Mendoza",
    "timezone": "-03:00",
    "countryIndex": 11,
    "dsts": "<-03>3"
  },
  {
    "name": "Argentina",
    "zone": "America/Argentina/San_Luis",
    "timezone": "-03:00",
    "countryIndex": 11,
    "dsts": "<-03>3"
  },
  {
    "name": "Argentina",
    "zone": "America/Argentina/Rio_Gallegos",
    "timezone": "-03:00",
    "countryIndex": 11,
    "dsts": "<-03>3"
  },
  {
    "name": "Argentina",
    "zone": "America/Argentina/Ushuaia",
    "timezone": "-03:00",
    "countryIndex": 11,
    "dsts": "<-03>3"
  },
  {
    "name": "American Samoa",
    "zone": "Pacific/Pago_Pago",
    "timezone": "-11:00",
    "countryIndex": 5,
    "dsts": "SST11"
  },
  {
    "name": "Austria",
    "zone": "Europe/Vienna",
    "timezone": "+01:00",
    "countryIndex": 15,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Australia",
    "zone": "Australia/Lord_Howe",
    "timezone": "+10:30",
    "countryIndex": 14,
    "dsts": "<+1030>-10:30<+11>-11,M10.1.0,M4.1.0"
  },
  {
    "name": "Australia",
    "zone": "Antarctica/Macquarie",
    "timezone": "+10:00",
    "countryIndex": 14,
    "dsts": "AEST-10AEDT,M10.1.0,M4.1.0/3"
  },
  {
    "name": "Australia",
    "zone": "Australia/Hobart",
    "timezone": "+10:00",
    "countryIndex": 14,
    "dsts": "AEST-10AEDT,M10.1.0,M4.1.0/3"
  },
  {
    "name": "Australia",
    "zone": "Australia/Melbourne",
    "timezone": "+10:00",
    "countryIndex": 14,
    "dsts": "AEST-10AEDT,M10.1.0,M4.1.0/3"
  },
  {
    "name": "Australia",
    "zone": "Australia/Sydney",
    "timezone": "+10:00",
    "countryIndex": 14,
    "dsts": "AEST-10AEDT,M10.1.0,M4.1.0/3"
  },
  {
    "name": "Australia",
    "zone": "Australia/Broken_Hill",
    "timezone": "+09:30",
    "countryIndex": 14,
    "dsts": "ACST-9:30ACDT,M10.1.0,M4.1.0/3"
  },
  {
    "name": "Australia",
    "zone": "Australia/Brisbane",
    "timezone": "+10:00",
    "countryIndex": 14,
    "dsts": "AEST-10"
  },
  {
    "name": "Australia",
    "zone": "Australia/Lindeman",
    "timezone": "+10:00",
    "countryIndex": 14,
    "dsts": "AEST-10"
  },
  {
    "name": "Australia",
    "zone": "Australia/Adelaide",
    "timezone": "+09:30",
    "countryIndex": 14,
    "dsts": "ACST-9:30ACDT,M10.1.0,M4.1.0/3"
  },
  {
    "name": "Australia",
    "zone": "Australia/Darwin",
    "timezone": "+09:30",
    "countryIndex": 14,
    "dsts": "ACST-9:30"
  },
  {
    "name": "Australia",
    "zone": "Australia/Perth",
    "timezone": "+08:00",
    "countryIndex": 14,
    "dsts": "AWST-8"
  },
  {
    "name": "Australia",
    "zone": "Australia/Eucla",
    "timezone": "+08:45",
    "countryIndex": 14,
    "dsts": "<+0845>-8:45"
  },
  {
    "name": "Aruba",
    "zone": "America/Aruba",
    "timezone": "-04:00",
    "countryIndex": 13,
    "dsts": "AST4"
  },
  {
    "name": "Aland Islands",
    "zone": "Europe/Mariehamn",
    "timezone": "+02:00",
    "countryIndex": 2,
    "dsts": "EET-2EEST,M3.5.0/3,M10.3.0/4"
  },
  {
    "name": "Azerbaijan",
    "zone": "Asia/Baku",
    "timezone": "+04:00",
    "countryIndex": 16,
    "dsts": "<+04>-4"
  },
  {
    "name": "Bosnia and Herzegovina",
    "zone": "Europe/Sarajevo",
    "timezone": "+01:00",
    "countryIndex": 29,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Barbados",
    "zone": "America/Barbados",
    "timezone": "-04:00",
    "countryIndex": 20,
    "dsts": "AST4"
  },
  {
    "name": "Bangladesh",
    "zone": "Asia/Dhaka",
    "timezone": "+06:00",
    "countryIndex": 19,
    "dsts": "<+06>-6"
  },
  {
    "name": "Belgium",
    "zone": "Europe/Brussels",
    "timezone": "+01:00",
    "countryIndex": 22,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Burkina Faso",
    "zone": "Africa/Ouagadougou",
    "timezone": "+00:00",
    "countryIndex": 36,
    "dsts": "GMT0"
  },
  {
    "name": "Bulgaria",
    "zone": "Europe/Sofia",
    "timezone": "+02:00",
    "countryIndex": 35,
    "dsts": "EET-2EEST,M3.5.0/3,M10.3.0/4"
  },
  {
    "name": "Bahrain",
    "zone": "Asia/Bahrain",
    "timezone": "+03:00",
    "countryIndex": 18,
    "dsts": "<+03>-3"
  },
  {
    "name": "Burundi",
    "zone": "Africa/Bujumbura",
    "timezone": "+02:00",
    "countryIndex": 37,
    "dsts": "CAT-2"
  },
  {
    "name": "Benin",
    "zone": "Africa/Porto-Novo",
    "timezone": "+01:00",
    "countryIndex": 24,
    "dsts": "WAT-1"
  },
  {
    "name": "Saint Barthélemy",
    "zone": "America/St_Barthelemy",
    "timezone": "-04:00",
    "countryIndex": 183,
    "dsts": "AST4"
  },
  {
    "name": "Bermuda",
    "zone": "Atlantic/Bermuda",
    "timezone": "-04:00",
    "countryIndex": 25,
    "dsts": "AST4ADT,M3.1.0,M11.1.0"
  },
  {
    "name": "Brunei",
    "zone": "Asia/Brunei",
    "timezone": "+08:00",
    "countryIndex": 34,
    "dsts": "<+08>-8"
  },
  {
    "name": "Bolivia",
    "zone": "America/La_Paz",
    "timezone": "-04:00",
    "countryIndex": 27,
    "dsts": "<-04>4"
  },
  {
    "name": "Bonaire, Saint Eustatius and Saba",
    "zone": "America/Kralendijk",
    "timezone": "-04:00",
    "countryIndex": 28,
    "dsts": "AST4"
  },
  {
    "name": "Brazil",
    "zone": "America/Noronha",
    "timezone": "-02:00",
    "countryIndex": 31,
    "dsts": "<-02>2"
  },
  {
    "name": "Brazil",
    "zone": "America/Belem",
    "timezone": "-03:00",
    "countryIndex": 31,
    "dsts": "<-03>3"
  },
  {
    "name": "Brazil",
    "zone": "America/Fortaleza",
    "timezone": "-03:00",
    "countryIndex": 31,
    "dsts": "<-03>3"
  },
  {
    "name": "Brazil",
    "zone": "America/Recife",
    "timezone": "-03:00",
    "countryIndex": 31,
    "dsts": "<-03>3"
  },
  {
    "name": "Brazil",
    "zone": "America/Araguaina",
    "timezone": "-03:00",
    "countryIndex": 31,
    "dsts": "<-03>3"
  },
  {
    "name": "Brazil",
    "zone": "America/Maceio",
    "timezone": "-03:00",
    "countryIndex": 31,
    "dsts": "<-03>3"
  },
  {
    "name": "Brazil",
    "zone": "America/Bahia",
    "timezone": "-03:00",
    "countryIndex": 31,
    "dsts": "<-03>3"
  },
  {
    "name": "Brazil",
    "zone": "America/Sao_Paulo",
    "timezone": "-03:00",
    "countryIndex": 31,
    "dsts": "<-03>3"
  },
  {
    "name": "Brazil",
    "zone": "America/Campo_Grande",
    "timezone": "-04:00",
    "countryIndex": 31,
    "dsts": "<-04>4"
  },
  {
    "name": "Brazil",
    "zone": "America/Cuiaba",
    "timezone": "-04:00",
    "countryIndex": 31,
    "dsts": "<-04>4"
  },
  {
    "name": "Brazil",
    "zone": "America/Santarem",
    "timezone": "-03:00",
    "countryIndex": 31,
    "dsts": "<-03>3"
  },
  {
    "name": "Brazil",
    "zone": "America/Porto_Velho",
    "timezone": "-04:00",
    "countryIndex": 31,
    "dsts": "<-04>4"
  },
  {
    "name": "Brazil",
    "zone": "America/Boa_Vista",
    "timezone": "-04:00",
    "countryIndex": 31,
    "dsts": "<-04>4"
  },
  {
    "name": "Brazil",
    "zone": "America/Manaus",
    "timezone": "-04:00",
    "countryIndex": 31,
    "dsts": "<-04>4"
  },
  {
    "name": "Brazil",
    "zone": "America/Eirunepe",
    "timezone": "-05:00",
    "countryIndex": 31,
    "dsts": "<-05>5"
  },
  {
    "name": "Brazil",
    "zone": "America/Rio_Branco",
    "timezone": "-05:00",
    "countryIndex": 31,
    "dsts": "<-05>5"
  },
  {
    "name": "Bahamas",
    "zone": "America/Nassau",
    "timezone": "-05:00",
    "countryIndex": 17,
    "dsts": "EST5EDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Bhutan",
    "zone": "Asia/Thimphu",
    "timezone": "+06:00",
    "countryIndex": 26,
    "dsts": "<+06>-6"
  },
  {
    "name": "Botswana",
    "zone": "Africa/Gaborone",
    "timezone": "+02:00",
    "countryIndex": 30,
    "dsts": "CAT-2"
  },
  {
    "name": "Belarus",
    "zone": "Europe/Minsk",
    "timezone": "+03:00",
    "countryIndex": 21,
    "dsts": "<+03>-3"
  },
  {
    "name": "Belize",
    "zone": "America/Belize",
    "timezone": "-06:00",
    "countryIndex": 23,
    "dsts": "CST6"
  },
  {
    "name": "Canada",
    "zone": "America/St_Johns",
    "timezone": "-03:30",
    "countryIndex": 40,
    "dsts": "NST3:30NDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Canada",
    "zone": "America/Halifax",
    "timezone": "-04:00",
    "countryIndex": 40,
    "dsts": "AST4ADT,M3.1.0,M11.1.0"
  },
  {
    "name": "Canada",
    "zone": "America/Glace_Bay",
    "timezone": "-04:00",
    "countryIndex": 40,
    "dsts": "AST4ADT,M3.1.0,M11.1.0"
  },
  {
    "name": "Canada",
    "zone": "America/Moncton",
    "timezone": "-04:00",
    "countryIndex": 40,
    "dsts": "AST4ADT,M3.1.0,M11.1.0"
  },
  {
    "name": "Canada",
    "zone": "America/Goose_Bay",
    "timezone": "-04:00",
    "countryIndex": 40,
    "dsts": "AST4ADT,M3.1.0,M11.1.0"
  },
  {
    "name": "Canada",
    "zone": "America/Blanc-Sablon",
    "timezone": "-04:00",
    "countryIndex": 40,
    "dsts": "AST4"
  },
  {
    "name": "Canada",
    "zone": "America/Toronto",
    "timezone": "-05:00",
    "countryIndex": 40,
    "dsts": "EST5EDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Canada",
    "zone": "America/Iqaluit",
    "timezone": "-05:00",
    "countryIndex": 40,
    "dsts": "EST5EDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Canada",
    "zone": "America/Atikokan",
    "timezone": "-05:00",
    "countryIndex": 40,
    "dsts": "EST5"
  },
  {
    "name": "Canada",
    "zone": "America/Winnipeg",
    "timezone": "-06:00",
    "countryIndex": 40,
    "dsts": "CST6CDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Canada",
    "zone": "America/Resolute",
    "timezone": "-06:00",
    "countryIndex": 40,
    "dsts": "CST6CDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Canada",
    "zone": "America/Rankin_Inlet",
    "timezone": "-06:00",
    "countryIndex": 40,
    "dsts": "CST6CDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Canada",
    "zone": "America/Regina",
    "timezone": "-06:00",
    "countryIndex": 40,
    "dsts": "CST6"
  },
  {
    "name": "Canada",
    "zone": "America/Swift_Current",
    "timezone": "-06:00",
    "countryIndex": 40,
    "dsts": "CST6"
  },
  {
    "name": "Canada",
    "zone": "America/Edmonton",
    "timezone": "-07:00",
    "countryIndex": 40,
    "dsts": "MST7MDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Canada",
    "zone": "America/Cambridge_Bay",
    "timezone": "-07:00",
    "countryIndex": 40,
    "dsts": "MST7MDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Canada",
    "zone": "America/Inuvik",
    "timezone": "-07:00",
    "countryIndex": 40,
    "dsts": "MST7MDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Canada",
    "zone": "America/Creston",
    "timezone": "-07:00",
    "countryIndex": 40,
    "dsts": "MST7"
  },
  {
    "name": "Canada",
    "zone": "America/Dawson_Creek",
    "timezone": "-07:00",
    "countryIndex": 40,
    "dsts": "MST7"
  },
  {
    "name": "Canada",
    "zone": "America/Fort_Nelson",
    "timezone": "-07:00",
    "countryIndex": 40,
    "dsts": "MST7"
  },
  {
    "name": "Canada",
    "zone": "America/Whitehorse",
    "timezone": "-07:00",
    "countryIndex": 40,
    "dsts": "MST7"
  },
  {
    "name": "Canada",
    "zone": "America/Dawson",
    "timezone": "-07:00",
    "countryIndex": 40,
    "dsts": "MST7"
  },
  {
    "name": "Canada",
    "zone": "America/Vancouver",
    "timezone": "-08:00",
    "countryIndex": 40,
    "dsts": "PST8PDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Cocos Islands",
    "zone": "Indian/Cocos",
    "timezone": "+06:30",
    "countryIndex": 48,
    "dsts": "<+0630>-6:30"
  },
  {
    "name": "Democratic Republic of the Congo",
    "zone": "Africa/Kinshasa",
    "timezone": "+01:00",
    "countryIndex": 58,
    "dsts": "WAT-1"
  },
  {
    "name": "Democratic Republic of the Congo",
    "zone": "Africa/Lubumbashi",
    "timezone": "+02:00",
    "countryIndex": 58,
    "dsts": "CAT-2"
  },
  {
    "name": "Central African Republic",
    "zone": "Africa/Bangui",
    "timezone": "+01:00",
    "countryIndex": 43,
    "dsts": "WAT-1"
  },
  {
    "name": "Republic of the Congo",
    "zone": "Africa/Brazzaville",
    "timezone": "+01:00",
    "countryIndex": 178,
    "dsts": "WAT-1"
  },
  {
    "name": "Switzerland",
    "zone": "Europe/Zurich",
    "timezone": "+01:00",
    "countryIndex": 214,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Ivory Coast",
    "zone": "Africa/Abidjan",
    "timezone": "+00:00",
    "countryIndex": 108,
    "dsts": "GMT0"
  },
  {
    "name": "Cook Islands",
    "zone": "Pacific/Rarotonga",
    "timezone": "-10:00",
    "countryIndex": 51,
    "dsts": "<-10>10"
  },
  {
    "name": "Chile",
    "zone": "America/Santiago",
    "timezone": "-04:00",
    "countryIndex": 45,
    "dsts": "<-04>4<-03>,M9.1.0/0,M4.1.0/0"
  },
  {
    "name": "Chile",
    "zone": "America/Coyhaique",
    "timezone": "-03:00",
    "countryIndex": 45,
    "dsts": "<-03>3"
  },
  {
    "name": "Chile",
    "zone": "America/Punta_Arenas",
    "timezone": "-03:00",
    "countryIndex": 45,
    "dsts": "<-03>3"
  },
  {
    "name": "Chile",
    "zone": "Pacific/Easter",
    "timezone": "-06:00",
    "countryIndex": 45,
    "dsts": "<-06>6<-05>,M9.1.6/22,M4.1.6/22"
  },
  {
    "name": "Cameroon",
    "zone": "Africa/Douala",
    "timezone": "+01:00",
    "countryIndex": 39,
    "dsts": "WAT-1"
  },
  {
    "name": "China",
    "zone": "Asia/Shanghai",
    "timezone": "+08:00",
    "countryIndex": 46,
    "dsts": "CST-8"
  },
  {
    "name": "China",
    "zone": "Asia/Urumqi",
    "timezone": "+06:00",
    "countryIndex": 46,
    "dsts": "<+06>-6"
  },
  {
    "name": "Colombia",
    "zone": "America/Bogota",
    "timezone": "-05:00",
    "countryIndex": 49,
    "dsts": "<-05>5"
  },
  {
    "name": "Costa Rica",
    "zone": "America/Costa_Rica",
    "timezone": "-06:00",
    "countryIndex": 52,
    "dsts": "CST6"
  },
  {
    "name": "Cuba",
    "zone": "America/Havana",
    "timezone": "-05:00",
    "countryIndex": 54,
    "dsts": "CST5CDT,M3.1.0/0,M11.1.0/1"
  },
  {
    "name": "Cape Verde",
    "zone": "Atlantic/Cape_Verde",
    "timezone": "-01:00",
    "countryIndex": 41,
    "dsts": "<-01>1"
  },
  {
    "name": "Curaçao",
    "zone": "America/Curacao",
    "timezone": "-04:00",
    "countryIndex": 55,
    "dsts": "AST4"
  },
  {
    "name": "Christmas Island",
    "zone": "Indian/Christmas",
    "timezone": "+07:00",
    "countryIndex": 47,
    "dsts": "<+07>-7"
  },
  {
    "name": "Cyprus",
    "zone": "Asia/Nicosia",
    "timezone": "+02:00",
    "countryIndex": 56,
    "dsts": "EET-2EEST,M3.5.0/3,M10.3.0/4"
  },
  {
    "name": "Cyprus",
    "zone": "Asia/Famagusta",
    "timezone": "+02:00",
    "countryIndex": 56,
    "dsts": "EET-2EEST,M3.5.0/3,M10.3.0/4"
  },
  {
    "name": "Czech Republic",
    "zone": "Europe/Prague",
    "timezone": "+01:00",
    "countryIndex": 57,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Germany",
    "zone": "Europe/Berlin",
    "timezone": "+01:00",
    "countryIndex": 82,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Germany",
    "zone": "Europe/Busingen",
    "timezone": "+01:00",
    "countryIndex": 82,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Djibouti",
    "zone": "Africa/Djibouti",
    "timezone": "+03:00",
    "countryIndex": 60,
    "dsts": "EAT-3"
  },
  {
    "name": "Denmark",
    "zone": "Europe/Copenhagen",
    "timezone": "+01:00",
    "countryIndex": 59,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Dominica",
    "zone": "America/Dominica",
    "timezone": "-04:00",
    "countryIndex": 61,
    "dsts": "AST4"
  },
  {
    "name": "Dominican Republic",
    "zone": "America/Santo_Domingo",
    "timezone": "-04:00",
    "countryIndex": 62,
    "dsts": "AST4"
  },
  {
    "name": "Algeria",
    "zone": "Africa/Algiers",
    "timezone": "+01:00",
    "countryIndex": 4,
    "dsts": "CET-1"
  },
  {
    "name": "Ecuador",
    "zone": "America/Guayaquil",
    "timezone": "-05:00",
    "countryIndex": 64,
    "dsts": "<-05>5"
  },
  {
    "name": "Ecuador",
    "zone": "Pacific/Galapagos",
    "timezone": "-06:00",
    "countryIndex": 64,
    "dsts": "<-06>6"
  },
  {
    "name": "Estonia",
    "zone": "Europe/Tallinn",
    "timezone": "+02:00",
    "countryIndex": 69,
    "dsts": "EET-2EEST,M3.5.0/3,M10.3.0/4"
  },
  {
    "name": "Egypt",
    "zone": "Africa/Cairo",
    "timezone": "+02:00",
    "countryIndex": 65,
    "dsts": "EET-2EEST,M4.3.5/0,M10.5.5/0"
  },
  {
    "name": "Western Sahara",
    "zone": "Africa/El_Aaiun",
    "timezone": "+01:00",
    "countryIndex": 244,
    "dsts": "<+01>-1"
  },
  {
    "name": "Eritrea",
    "zone": "Africa/Asmara",
    "timezone": "+03:00",
    "countryIndex": 68,
    "dsts": "EAT-3"
  },
  {
    "name": "Spain",
    "zone": "Europe/Madrid",
    "timezone": "+01:00",
    "countryIndex": 207,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Spain",
    "zone": "Africa/Ceuta",
    "timezone": "+01:00",
    "countryIndex": 207,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Spain",
    "zone": "Atlantic/Canary",
    "timezone": "+00:00",
    "countryIndex": 207,
    "dsts": "WET0WEST,M3.5.0/1,M10.3.0"
  },
  {
    "name": "Ethiopia",
    "zone": "Africa/Addis_Ababa",
    "timezone": "+03:00",
    "countryIndex": 70,
    "dsts": "EAT-3"
  },
  {
    "name": "Finland",
    "zone": "Europe/Helsinki",
    "timezone": "+02:00",
    "countryIndex": 74,
    "dsts": "EET-2EEST,M3.5.0/3,M10.3.0/4"
  },
  {
    "name": "Fiji",
    "zone": "Pacific/Fiji",
    "timezone": "+12:00",
    "countryIndex": 73,
    "dsts": "<+12>-12"
  },
  {
    "name": "Falkland Islands",
    "zone": "Atlantic/Stanley",
    "timezone": "-03:00",
    "countryIndex": 71,
    "dsts": "<-03>3"
  },
  {
    "name": "Micronesia",
    "zone": "Pacific/Chuuk",
    "timezone": "+10:00",
    "countryIndex": 141,
    "dsts": "<+10>-10"
  },
  {
    "name": "Micronesia",
    "zone": "Pacific/Pohnpei",
    "timezone": "+11:00",
    "countryIndex": 141,
    "dsts": "<+11>-11"
  },
  {
    "name": "Micronesia",
    "zone": "Pacific/Kosrae",
    "timezone": "+11:00",
    "countryIndex": 141,
    "dsts": "<+11>-11"
  },
  {
    "name": "Faroe Islands",
    "zone": "Atlantic/Faroe",
    "timezone": "+00:00",
    "countryIndex": 72,
    "dsts": "WET0WEST,M3.5.0/1,M10.3.0"
  },
  {
    "name": "France",
    "zone": "Europe/Paris",
    "timezone": "+01:00",
    "countryIndex": 75,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Gabon",
    "zone": "Africa/Libreville",
    "timezone": "+01:00",
    "countryIndex": 79,
    "dsts": "WAT-1"
  },
  {
    "name": "United Kingdom",
    "zone": "Europe/London",
    "timezone": "+00:00",
    "countryIndex": 233,
    "dsts": "GMT0BST,M3.5.0/1,M10.3.0"
  },
  {
    "name": "Grenada",
    "zone": "America/Grenada",
    "timezone": "-04:00",
    "countryIndex": 87,
    "dsts": "AST4"
  },
  {
    "name": "Georgia",
    "zone": "Asia/Tbilisi",
    "timezone": "+04:00",
    "countryIndex": 81,
    "dsts": "<+04>-4"
  },
  {
    "name": "French Guiana",
    "zone": "America/Cayenne",
    "timezone": "-03:00",
    "countryIndex": 76,
    "dsts": "<-03>3"
  },
  {
    "name": "Guernsey",
    "zone": "Europe/Guernsey",
    "timezone": "+00:00",
    "countryIndex": 91,
    "dsts": "GMT0BST,M3.5.0/1,M10.3.0"
  },
  {
    "name": "Ghana",
    "zone": "Africa/Accra",
    "timezone": "+00:00",
    "countryIndex": 83,
    "dsts": "GMT0"
  },
  {
    "name": "Gibraltar",
    "zone": "Europe/Gibraltar",
    "timezone": "+01:00",
    "countryIndex": 84,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Greenland",
    "zone": "America/Nuuk",
    "timezone": "-02:00",
    "countryIndex": 86,
    "dsts": "<-02>2<-01>,M3.5.6/23,M10.3.0/0"
  },
  {
    "name": "Greenland",
    "zone": "America/Danmarkshavn",
    "timezone": "+00:00",
    "countryIndex": 86,
    "dsts": "GMT0"
  },
  {
    "name": "Greenland",
    "zone": "America/Scoresbysund",
    "timezone": "-02:00",
    "countryIndex": 86,
    "dsts": "<-02>2<-01>,M3.5.6/23,M10.3.0/0"
  },
  {
    "name": "Greenland",
    "zone": "America/Thule",
    "timezone": "-04:00",
    "countryIndex": 86,
    "dsts": "AST4ADT,M3.1.0,M11.1.0"
  },
  {
    "name": "Gambia",
    "zone": "Africa/Banjul",
    "timezone": "+00:00",
    "countryIndex": 80,
    "dsts": "GMT0"
  },
  {
    "name": "Guinea",
    "zone": "Africa/Conakry",
    "timezone": "+00:00",
    "countryIndex": 92,
    "dsts": "GMT0"
  },
  {
    "name": "Guadeloupe",
    "zone": "America/Guadeloupe",
    "timezone": "-04:00",
    "countryIndex": 88,
    "dsts": "AST4"
  },
  {
    "name": "Equatorial Guinea",
    "zone": "Africa/Malabo",
    "timezone": "+01:00",
    "countryIndex": 67,
    "dsts": "WAT-1"
  },
  {
    "name": "Greece",
    "zone": "Europe/Athens",
    "timezone": "+02:00",
    "countryIndex": 85,
    "dsts": "EET-2EEST,M3.5.0/3,M10.3.0/4"
  },
  {
    "name": "South Georgia and the South Sandwich Islands",
    "zone": "Atlantic/South_Georgia",
    "timezone": "-02:00",
    "countryIndex": 204,
    "dsts": "<-02>2"
  },
  {
    "name": "Guatemala",
    "zone": "America/Guatemala",
    "timezone": "-06:00",
    "countryIndex": 90,
    "dsts": "CST6"
  },
  {
    "name": "Guam",
    "zone": "Pacific/Guam",
    "timezone": "+10:00",
    "countryIndex": 89,
    "dsts": "ChST-10"
  },
  {
    "name": "Guinea-Bissau",
    "zone": "Africa/Bissau",
    "timezone": "+00:00",
    "countryIndex": 93,
    "dsts": "GMT0"
  },
  {
    "name": "Guyana",
    "zone": "America/Guyana",
    "timezone": "-04:00",
    "countryIndex": 94,
    "dsts": "<-04>4"
  },
  {
    "name": "Hong Kong",
    "zone": "Asia/Hong_Kong",
    "timezone": "+08:00",
    "countryIndex": 97,
    "dsts": "HKT-8"
  },
  {
    "name": "Honduras",
    "zone": "America/Tegucigalpa",
    "timezone": "-06:00",
    "countryIndex": 96,
    "dsts": "CST6"
  },
  {
    "name": "Croatia",
    "zone": "Europe/Zagreb",
    "timezone": "+01:00",
    "countryIndex": 53,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Haiti",
    "zone": "America/Port-au-Prince",
    "timezone": "-05:00",
    "countryIndex": 95,
    "dsts": "EST5EDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Hungary",
    "zone": "Europe/Budapest",
    "timezone": "+01:00",
    "countryIndex": 98,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Indonesia",
    "zone": "Asia/Jakarta",
    "timezone": "+07:00",
    "countryIndex": 101,
    "dsts": "WIB-7"
  },
  {
    "name": "Indonesia",
    "zone": "Asia/Pontianak",
    "timezone": "+07:00",
    "countryIndex": 101,
    "dsts": "WIB-7"
  },
  {
    "name": "Indonesia",
    "zone": "Asia/Makassar",
    "timezone": "+08:00",
    "countryIndex": 101,
    "dsts": "WITA-8"
  },
  {
    "name": "Indonesia",
    "zone": "Asia/Jayapura",
    "timezone": "+09:00",
    "countryIndex": 101,
    "dsts": "WIT-9"
  },
  {
    "name": "Ireland",
    "zone": "Europe/Dublin",
    "timezone": "+00:00",
    "countryIndex": 104,
    "dsts": "GMT0IST,M3.5.0/1,M10.3.0"
  },
  {
    "name": "Israel",
    "zone": "Asia/Jerusalem",
    "timezone": "+02:00",
    "countryIndex": 106,
    "dsts": "IST-2IDT,M3.5.5,M10.3.0"
  },
  {
    "name": "Isle of Man",
    "zone": "Europe/Isle_of_Man",
    "timezone": "+00:00",
    "countryIndex": 105,
    "dsts": "GMT0BST,M3.5.0/1,M10.3.0"
  },
  {
    "name": "India",
    "zone": "Asia/Kolkata",
    "timezone": "+05:30",
    "countryIndex": 100,
    "dsts": "IST-5:30"
  },
  {
    "name": "British Indian Ocean Territory",
    "zone": "Indian/Chagos",
    "timezone": "+06:00",
    "countryIndex": 32,
    "dsts": "<+06>-6"
  },
  {
    "name": "Iraq",
    "zone": "Asia/Baghdad",
    "timezone": "+03:00",
    "countryIndex": 103,
    "dsts": "<+03>-3"
  },
  {
    "name": "Iran",
    "zone": "Asia/Tehran",
    "timezone": "+03:30",
    "countryIndex": 102,
    "dsts": "<+0330>-3:30"
  },
  {
    "name": "Iceland",
    "zone": "Atlantic/Reykjavik",
    "timezone": "+00:00",
    "countryIndex": 99,
    "dsts": "GMT0"
  },
  {
    "name": "Italy",
    "zone": "Europe/Rome",
    "timezone": "+01:00",
    "countryIndex": 107,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Jersey",
    "zone": "Europe/Jersey",
    "timezone": "+00:00",
    "countryIndex": 111,
    "dsts": "GMT0BST,M3.5.0/1,M10.3.0"
  },
  {
    "name": "Jamaica",
    "zone": "America/Jamaica",
    "timezone": "-05:00",
    "countryIndex": 109,
    "dsts": "EST5"
  },
  {
    "name": "Jordan",
    "zone": "Asia/Amman",
    "timezone": "+03:00",
    "countryIndex": 112,
    "dsts": "<+03>-3"
  },
  {
    "name": "Japan",
    "zone": "Asia/Tokyo",
    "timezone": "+09:00",
    "countryIndex": 110,
    "dsts": "JST-9"
  },
  {
    "name": "Kenya",
    "zone": "Africa/Nairobi",
    "timezone": "+03:00",
    "countryIndex": 114,
    "dsts": "EAT-3"
  },
  {
    "name": "Kyrgyzstan",
    "zone": "Asia/Bishkek",
    "timezone": "+06:00",
    "countryIndex": 117,
    "dsts": "<+06>-6"
  },
  {
    "name": "Cambodia",
    "zone": "Asia/Phnom_Penh",
    "timezone": "+07:00",
    "countryIndex": 38,
    "dsts": "<+07>-7"
  },
  {
    "name": "Kiribati",
    "zone": "Pacific/Tarawa",
    "timezone": "+12:00",
    "countryIndex": 115,
    "dsts": "<+12>-12"
  },
  {
    "name": "Kiribati",
    "zone": "Pacific/Kanton",
    "timezone": "+13:00",
    "countryIndex": 115,
    "dsts": "<+13>-13"
  },
  {
    "name": "Kiribati",
    "zone": "Pacific/Kiritimati",
    "timezone": "+14:00",
    "countryIndex": 115,
    "dsts": "<+14>-14"
  },
  {
    "name": "Comoros",
    "zone": "Indian/Comoro",
    "timezone": "+03:00",
    "countryIndex": 50,
    "dsts": "EAT-3"
  },
  {
    "name": "Saint Kitts and Nevis",
    "zone": "America/St_Kitts",
    "timezone": "-04:00",
    "countryIndex": 185,
    "dsts": "AST4"
  },
  {
    "name": "North Korea",
    "zone": "Asia/Pyongyang",
    "timezone": "+09:00",
    "countryIndex": 161,
    "dsts": "KST-9"
  },
  {
    "name": "South Korea",
    "zone": "Asia/Seoul",
    "timezone": "+09:00",
    "countryIndex": 205,
    "dsts": "KST-9"
  },
  {
    "name": "Kuwait",
    "zone": "Asia/Kuwait",
    "timezone": "+03:00",
    "countryIndex": 116,
    "dsts": "<+03>-3"
  },
  {
    "name": "Cayman Islands",
    "zone": "America/Cayman",
    "timezone": "-05:00",
    "countryIndex": 42,
    "dsts": "EST5"
  },
  {
    "name": "Kazakhstan",
    "zone": "Asia/Almaty",
    "timezone": "+05:00",
    "countryIndex": 113,
    "dsts": "<+05>-5"
  },
  {
    "name": "Kazakhstan",
    "zone": "Asia/Qyzylorda",
    "timezone": "+05:00",
    "countryIndex": 113,
    "dsts": "<+05>-5"
  },
  {
    "name": "Kazakhstan",
    "zone": "Asia/Qostanay",
    "timezone": "+05:00",
    "countryIndex": 113,
    "dsts": "<+05>-5"
  },
  {
    "name": "Kazakhstan",
    "zone": "Asia/Aqtobe",
    "timezone": "+05:00",
    "countryIndex": 113,
    "dsts": "<+05>-5"
  },
  {
    "name": "Kazakhstan",
    "zone": "Asia/Aqtau",
    "timezone": "+05:00",
    "countryIndex": 113,
    "dsts": "<+05>-5"
  },
  {
    "name": "Kazakhstan",
    "zone": "Asia/Atyrau",
    "timezone": "+05:00",
    "countryIndex": 113,
    "dsts": "<+05>-5"
  },
  {
    "name": "Kazakhstan",
    "zone": "Asia/Oral",
    "timezone": "+05:00",
    "countryIndex": 113,
    "dsts": "<+05>-5"
  },
  {
    "name": "Laos",
    "zone": "Asia/Vientiane",
    "timezone": "+07:00",
    "countryIndex": 118,
    "dsts": "<+07>-7"
  },
  {
    "name": "Lebanon",
    "zone": "Asia/Beirut",
    "timezone": "+02:00",
    "countryIndex": 120,
    "dsts": "EET-2EEST,M3.5.0/0,M10.3.0/0"
  },
  {
    "name": "Saint Lucia",
    "zone": "America/St_Lucia",
    "timezone": "-04:00",
    "countryIndex": 186,
    "dsts": "AST4"
  },
  {
    "name": "Liechtenstein",
    "zone": "Europe/Vaduz",
    "timezone": "+01:00",
    "countryIndex": 124,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Sri Lanka",
    "zone": "Asia/Colombo",
    "timezone": "+05:30",
    "countryIndex": 208,
    "dsts": "<+0530>-5:30"
  },
  {
    "name": "Liberia",
    "zone": "Africa/Monrovia",
    "timezone": "+00:00",
    "countryIndex": 122,
    "dsts": "GMT0"
  },
  {
    "name": "Lesotho",
    "zone": "Africa/Maseru",
    "timezone": "+02:00",
    "countryIndex": 121,
    "dsts": "SAST-2"
  },
  {
    "name": "Lithuania",
    "zone": "Europe/Vilnius",
    "timezone": "+02:00",
    "countryIndex": 125,
    "dsts": "EET-2EEST,M3.5.0/3,M10.3.0/4"
  },
  {
    "name": "Luxembourg",
    "zone": "Europe/Luxembourg",
    "timezone": "+01:00",
    "countryIndex": 126,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Latvia",
    "zone": "Europe/Riga",
    "timezone": "+02:00",
    "countryIndex": 119,
    "dsts": "EET-2EEST,M3.5.0/3,M10.3.0/4"
  },
  {
    "name": "Libya",
    "zone": "Africa/Tripoli",
    "timezone": "+02:00",
    "countryIndex": 123,
    "dsts": "EET-2"
  },
  {
    "name": "Morocco",
    "zone": "Africa/Casablanca",
    "timezone": "+01:00",
    "countryIndex": 147,
    "dsts": "<+01>-1"
  },
  {
    "name": "Monaco",
    "zone": "Europe/Monaco",
    "timezone": "+01:00",
    "countryIndex": 143,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Moldova",
    "zone": "Europe/Chisinau",
    "timezone": "+02:00",
    "countryIndex": 142,
    "dsts": "EET-2EEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Montenegro",
    "zone": "Europe/Podgorica",
    "timezone": "+01:00",
    "countryIndex": 145,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Saint Martin",
    "zone": "America/Marigot",
    "timezone": "-04:00",
    "countryIndex": 187,
    "dsts": "AST4"
  },
  {
    "name": "Madagascar",
    "zone": "Indian/Antananarivo",
    "timezone": "+03:00",
    "countryIndex": 129,
    "dsts": "EAT-3"
  },
  {
    "name": "Marshall Islands",
    "zone": "Pacific/Majuro",
    "timezone": "+12:00",
    "countryIndex": 135,
    "dsts": "<+12>-12"
  },
  {
    "name": "Marshall Islands",
    "zone": "Pacific/Kwajalein",
    "timezone": "+12:00",
    "countryIndex": 135,
    "dsts": "<+12>-12"
  },
  {
    "name": "Macedonia",
    "zone": "Europe/Skopje",
    "timezone": "+01:00",
    "countryIndex": 128,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Mali",
    "zone": "Africa/Bamako",
    "timezone": "+00:00",
    "countryIndex": 133,
    "dsts": "GMT0"
  },
  {
    "name": "Myanmar",
    "zone": "Asia/Yangon",
    "timezone": "+06:30",
    "countryIndex": 149,
    "dsts": "<+0630>-6:30"
  },
  {
    "name": "Mongolia",
    "zone": "Asia/Ulaanbaatar",
    "timezone": "+08:00",
    "countryIndex": 144,
    "dsts": "<+08>-8"
  },
  {
    "name": "Mongolia",
    "zone": "Asia/Hovd",
    "timezone": "+07:00",
    "countryIndex": 144,
    "dsts": "<+07>-7"
  },
  {
    "name": "Macao",
    "zone": "Asia/Macau",
    "timezone": "+08:00",
    "countryIndex": 127,
    "dsts": "CST-8"
  },
  {
    "name": "Northern Mariana Islands",
    "zone": "Pacific/Saipan",
    "timezone": "+10:00",
    "countryIndex": 162,
    "dsts": "ChST-10"
  },
  {
    "name": "Martinique",
    "zone": "America/Martinique",
    "timezone": "-04:00",
    "countryIndex": 136,
    "dsts": "AST4"
  },
  {
    "name": "Mauritania",
    "zone": "Africa/Nouakchott",
    "timezone": "+00:00",
    "countryIndex": 137,
    "dsts": "GMT0"
  },
  {
    "name": "Montserrat",
    "zone": "America/Montserrat",
    "timezone": "-04:00",
    "countryIndex": 146,
    "dsts": "AST4"
  },
  {
    "name": "Malta",
    "zone": "Europe/Malta",
    "timezone": "+01:00",
    "countryIndex": 134,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Mauritius",
    "zone": "Indian/Mauritius",
    "timezone": "+04:00",
    "countryIndex": 138,
    "dsts": "<+04>-4"
  },
  {
    "name": "Maldives",
    "zone": "Indian/Maldives",
    "timezone": "+05:00",
    "countryIndex": 132,
    "dsts": "<+05>-5"
  },
  {
    "name": "Malawi",
    "zone": "Africa/Blantyre",
    "timezone": "+02:00",
    "countryIndex": 130,
    "dsts": "CAT-2"
  },
  {
    "name": "Mexico",
    "zone": "America/Mexico_City",
    "timezone": "-06:00",
    "countryIndex": 140,
    "dsts": "CST6"
  },
  {
    "name": "Mexico",
    "zone": "America/Cancun",
    "timezone": "-05:00",
    "countryIndex": 140,
    "dsts": "EST5"
  },
  {
    "name": "Mexico",
    "zone": "America/Merida",
    "timezone": "-06:00",
    "countryIndex": 140,
    "dsts": "CST6"
  },
  {
    "name": "Mexico",
    "zone": "America/Monterrey",
    "timezone": "-06:00",
    "countryIndex": 140,
    "dsts": "CST6"
  },
  {
    "name": "Mexico",
    "zone": "America/Matamoros",
    "timezone": "-06:00",
    "countryIndex": 140,
    "dsts": "CST6CDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Mexico",
    "zone": "America/Chihuahua",
    "timezone": "-06:00",
    "countryIndex": 140,
    "dsts": "CST6"
  },
  {
    "name": "Mexico",
    "zone": "America/Ciudad_Juarez",
    "timezone": "-07:00",
    "countryIndex": 140,
    "dsts": "MST7MDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Mexico",
    "zone": "America/Ojinaga",
    "timezone": "-06:00",
    "countryIndex": 140,
    "dsts": "CST6CDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Mexico",
    "zone": "America/Mazatlan",
    "timezone": "-07:00",
    "countryIndex": 140,
    "dsts": "MST7"
  },
  {
    "name": "Mexico",
    "zone": "America/Bahia_Banderas",
    "timezone": "-06:00",
    "countryIndex": 140,
    "dsts": "CST6"
  },
  {
    "name": "Mexico",
    "zone": "America/Hermosillo",
    "timezone": "-07:00",
    "countryIndex": 140,
    "dsts": "MST7"
  },
  {
    "name": "Mexico",
    "zone": "America/Tijuana",
    "timezone": "-08:00",
    "countryIndex": 140,
    "dsts": "PST8PDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Malaysia",
    "zone": "Asia/Kuala_Lumpur",
    "timezone": "+08:00",
    "countryIndex": 131,
    "dsts": "<+08>-8"
  },
  {
    "name": "Malaysia",
    "zone": "Asia/Kuching",
    "timezone": "+08:00",
    "countryIndex": 131,
    "dsts": "<+08>-8"
  },
  {
    "name": "Mozambique",
    "zone": "Africa/Maputo",
    "timezone": "+02:00",
    "countryIndex": 148,
    "dsts": "CAT-2"
  },
  {
    "name": "Namibia",
    "zone": "Africa/Windhoek",
    "timezone": "+02:00",
    "countryIndex": 150,
    "dsts": "CAT-2"
  },
  {
    "name": "New Caledonia",
    "zone": "Pacific/Noumea",
    "timezone": "+11:00",
    "countryIndex": 154,
    "dsts": "<+11>-11"
  },
  {
    "name": "Niger",
    "zone": "Africa/Niamey",
    "timezone": "+01:00",
    "countryIndex": 157,
    "dsts": "WAT-1"
  },
  {
    "name": "Norfolk Island",
    "zone": "Pacific/Norfolk",
    "timezone": "+11:00",
    "countryIndex": 160,
    "dsts": "<+11>-11<+12>,M10.1.0,M4.1.0/3"
  },
  {
    "name": "Nigeria",
    "zone": "Africa/Lagos",
    "timezone": "+01:00",
    "countryIndex": 158,
    "dsts": "WAT-1"
  },
  {
    "name": "Nicaragua",
    "zone": "America/Managua",
    "timezone": "-06:00",
    "countryIndex": 156,
    "dsts": "CST6"
  },
  {
    "name": "Netherlands",
    "zone": "Europe/Amsterdam",
    "timezone": "+01:00",
    "countryIndex": 153,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Norway",
    "zone": "Europe/Oslo",
    "timezone": "+01:00",
    "countryIndex": 163,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Nepal",
    "zone": "Asia/Kathmandu",
    "timezone": "+05:45",
    "countryIndex": 152,
    "dsts": "<+0545>-5:45"
  },
  {
    "name": "Nauru",
    "zone": "Pacific/Nauru",
    "timezone": "+12:00",
    "countryIndex": 151,
    "dsts": "<+12>-12"
  },
  {
    "name": "Niue",
    "zone": "Pacific/Niue",
    "timezone": "-11:00",
    "countryIndex": 159,
    "dsts": "<-11>11"
  },
  {
    "name": "New Zealand",
    "zone": "Pacific/Auckland",
    "timezone": "+12:00",
    "countryIndex": 155,
    "dsts": "NZST-12NZDT,M9.5.0,M4.1.0/3"
  },
  {
    "name": "New Zealand",
    "zone": "Pacific/Chatham",
    "timezone": "+12:45",
    "countryIndex": 155,
    "dsts": "<+1245>-12:45<+1345>,M9.5.0/2:45,M4.1.0/3:45"
  },
  {
    "name": "Oman",
    "zone": "Asia/Muscat",
    "timezone": "+04:00",
    "countryIndex": 164,
    "dsts": "<+04>-4"
  },
  {
    "name": "Panama",
    "zone": "America/Panama",
    "timezone": "-05:00",
    "countryIndex": 168,
    "dsts": "EST5"
  },
  {
    "name": "Peru",
    "zone": "America/Lima",
    "timezone": "-05:00",
    "countryIndex": 171,
    "dsts": "<-05>5"
  },
  {
    "name": "French Polynesia",
    "zone": "Pacific/Tahiti",
    "timezone": "-10:00",
    "countryIndex": 77,
    "dsts": "<-10>10"
  },
  {
    "name": "French Polynesia",
    "zone": "Pacific/Marquesas",
    "timezone": "-09:30",
    "countryIndex": 77,
    "dsts": "<-0930>9:30"
  },
  {
    "name": "French Polynesia",
    "zone": "Pacific/Gambier",
    "timezone": "-09:00",
    "countryIndex": 77,
    "dsts": "<-09>9"
  },
  {
    "name": "Papua New Guinea",
    "zone": "Pacific/Port_Moresby",
    "timezone": "+10:00",
    "countryIndex": 169,
    "dsts": "<+10>-10"
  },
  {
    "name": "Papua New Guinea",
    "zone": "Pacific/Bougainville",
    "timezone": "+11:00",
    "countryIndex": 169,
    "dsts": "<+11>-11"
  },
  {
    "name": "Philippines",
    "zone": "Asia/Manila",
    "timezone": "+08:00",
    "countryIndex": 172,
    "dsts": "PST-8"
  },
  {
    "name": "Pakistan",
    "zone": "Asia/Karachi",
    "timezone": "+05:00",
    "countryIndex": 165,
    "dsts": "PKT-5"
  },
  {
    "name": "Poland",
    "zone": "Europe/Warsaw",
    "timezone": "+01:00",
    "countryIndex": 174,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "zone": "America/Miquelon",
    "timezone": "-03:00",
    "countryIndex": 188,
    "dsts": "<-03>3<-02>,M3.1.0,M11.1.0"
  },
  {
    "name": "Pitcairn",
    "zone": "Pacific/Pitcairn",
    "timezone": "-08:00",
    "countryIndex": 173,
    "dsts": "<-08>8"
  },
  {
    "name": "Puerto Rico",
    "zone": "America/Puerto_Rico",
    "timezone": "-04:00",
    "countryIndex": 176,
    "dsts": "AST4"
  },
  {
    "name": "Palestinian Territory",
    "zone": "Asia/Gaza",
    "timezone": "+02:00",
    "countryIndex": 167,
    "dsts": "EET-2EEST,M4.1.6,M10.3.6"
  },
  {
    "name": "Palestinian Territory",
    "zone": "Asia/Hebron",
    "timezone": "+02:00",
    "countryIndex": 167,
    "dsts": "EET-2EEST,M4.1.6,M10.3.6"
  },
  {
    "name": "Portugal",
    "zone": "Europe/Lisbon",
    "timezone": "+00:00",
    "countryIndex": 175,
    "dsts": "WET0WEST,M3.5.0/1,M10.3.0"
  },
  {
    "name": "Portugal",
    "zone": "Atlantic/Madeira",
    "timezone": "+00:00",
    "countryIndex": 175,
    "dsts": "WET0WEST,M3.5.0/1,M10.3.0"
  },
  {
    "name": "Portugal",
    "zone": "Atlantic/Azores",
    "timezone": "-01:00",
    "countryIndex": 175,
    "dsts": "<-01>1<+00>,M3.5.0/0,M10.3.0/1"
  },
  {
    "name": "Palau",
    "zone": "Pacific/Palau",
    "timezone": "+09:00",
    "countryIndex": 166,
    "dsts": "<+09>-9"
  },
  {
    "name": "Paraguay",
    "zone": "America/Asuncion",
    "timezone": "-03:00",
    "countryIndex": 170,
    "dsts": "<-03>3"
  },
  {
    "name": "Qatar",
    "zone": "Asia/Qatar",
    "timezone": "+03:00",
    "countryIndex": 177,
    "dsts": "<+03>-3"
  },
  {
    "name": "Reunion",
    "zone": "Indian/Reunion",
    "timezone": "+04:00",
    "countryIndex": 179,
    "dsts": "<+04>-4"
  },
  {
    "name": "Romania",
    "zone": "Europe/Bucharest",
    "timezone": "+02:00",
    "countryIndex": 180,
    "dsts": "EET-2EEST,M3.5.0/3,M10.3.0/4"
  },
  {
    "name": "Serbia",
    "zone": "Europe/Belgrade",
    "timezone": "+01:00",
    "countryIndex": 195,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Russia",
    "zone": "Europe/Kaliningrad",
    "timezone": "+02:00",
    "countryIndex": 181,
    "dsts": "EET-2"
  },
  {
    "name": "Russia",
    "zone": "Europe/Moscow",
    "timezone": "+03:00",
    "countryIndex": 181,
    "dsts": "MSK-3"
  },
  {
    "name": "Ukraine",
    "zone": "Europe/Simferopol",
    "timezone": "+03:00",
    "countryIndex": 231,
    "dsts": "MSK-3"
  },
  {
    "name": "Russia",
    "zone": "Europe/Kirov",
    "timezone": "+03:00",
    "countryIndex": 181,
    "dsts": "MSK-3"
  },
  {
    "name": "Russia",
    "zone": "Europe/Volgograd",
    "timezone": "+03:00",
    "countryIndex": 181,
    "dsts": "MSK-3"
  },
  {
    "name": "Russia",
    "zone": "Europe/Astrakhan",
    "timezone": "+04:00",
    "countryIndex": 181,
    "dsts": "<+04>-4"
  },
  {
    "name": "Russia",
    "zone": "Europe/Saratov",
    "timezone": "+04:00",
    "countryIndex": 181,
    "dsts": "<+04>-4"
  },
  {
    "name": "Russia",
    "zone": "Europe/Ulyanovsk",
    "timezone": "+04:00",
    "countryIndex": 181,
    "dsts": "<+04>-4"
  },
  {
    "name": "Russia",
    "zone": "Europe/Samara",
    "timezone": "+04:00",
    "countryIndex": 181,
    "dsts": "<+04>-4"
  },
  {
    "name": "Russia",
    "zone": "Asia/Yekaterinburg",
    "timezone": "+05:00",
    "countryIndex": 181,
    "dsts": "<+05>-5"
  },
  {
    "name": "Russia",
    "zone": "Asia/Omsk",
    "timezone": "+06:00",
    "countryIndex": 181,
    "dsts": "<+06>-6"
  },
  {
    "name": "Russia",
    "zone": "Asia/Novosibirsk",
    "timezone": "+07:00",
    "countryIndex": 181,
    "dsts": "<+07>-7"
  },
  {
    "name": "Russia",
    "zone": "Asia/Barnaul",
    "timezone": "+07:00",
    "countryIndex": 181,
    "dsts": "<+07>-7"
  },
  {
    "name": "Russia",
    "zone": "Asia/Tomsk",
    "timezone": "+07:00",
    "countryIndex": 181,
    "dsts": "<+07>-7"
  },
  {
    "name": "Russia",
    "zone": "Asia/Novokuznetsk",
    "timezone": "+07:00",
    "countryIndex": 181,
    "dsts": "<+07>-7"
  },
  {
    "name": "Russia",
    "zone": "Asia/Krasnoyarsk",
    "timezone": "+07:00",
    "countryIndex": 181,
    "dsts": "<+07>-7"
  },
  {
    "name": "Russia",
    "zone": "Asia/Irkutsk",
    "timezone": "+08:00",
    "countryIndex": 181,
    "dsts": "<+08>-8"
  },
  {
    "name": "Russia",
    "zone": "Asia/Chita",
    "timezone": "+09:00",
    "countryIndex": 181,
    "dsts": "<+09>-9"
  },
  {
    "name": "Russia",
    "zone": "Asia/Yakutsk",
    "timezone": "+09:00",
    "countryIndex": 181,
    "dsts": "<+09>-9"
  },
  {
    "name": "Russia",
    "zone": "Asia/Khandyga",
    "timezone": "+09:00",
    "countryIndex": 181,
    "dsts": "<+09>-9"
  },
  {
    "name": "Russia",
    "zone": "Asia/Vladivostok",
    "timezone": "+10:00",
    "countryIndex": 181,
    "dsts": "<+10>-10"
  },
  {
    "name": "Russia",
    "zone": "Asia/Ust-Nera",
    "timezone": "+10:00",
    "countryIndex": 181,
    "dsts": "<+10>-10"
  },
  {
    "name": "Russia",
    "zone": "Asia/Magadan",
    "timezone": "+11:00",
    "countryIndex": 181,
    "dsts": "<+11>-11"
  },
  {
    "name": "Russia",
    "zone": "Asia/Sakhalin",
    "timezone": "+11:00",
    "countryIndex": 181,
    "dsts": "<+11>-11"
  },
  {
    "name": "Russia",
    "zone": "Asia/Srednekolymsk",
    "timezone": "+11:00",
    "countryIndex": 181,
    "dsts": "<+11>-11"
  },
  {
    "name": "Russia",
    "zone": "Asia/Kamchatka",
    "timezone": "+12:00",
    "countryIndex": 181,
    "dsts": "<+12>-12"
  },
  {
    "name": "Russia",
    "zone": "Asia/Anadyr",
    "timezone": "+12:00",
    "countryIndex": 181,
    "dsts": "<+12>-12"
  },
  {
    "name": "Rwanda",
    "zone": "Africa/Kigali",
    "timezone": "+02:00",
    "countryIndex": 182,
    "dsts": "CAT-2"
  },
  {
    "name": "Saudi Arabia",
    "zone": "Asia/Riyadh",
    "timezone": "+03:00",
    "countryIndex": 193,
    "dsts": "<+03>-3"
  },
  {
    "name": "Solomon Islands",
    "zone": "Pacific/Guadalcanal",
    "timezone": "+11:00",
    "countryIndex": 201,
    "dsts": "<+11>-11"
  },
  {
    "name": "Seychelles",
    "zone": "Indian/Mahe",
    "timezone": "+04:00",
    "countryIndex": 196,
    "dsts": "<+04>-4"
  },
  {
    "name": "Sudan",
    "zone": "Africa/Khartoum",
    "timezone": "+02:00",
    "countryIndex": 209,
    "dsts": "CAT-2"
  },
  {
    "name": "Sweden",
    "zone": "Europe/Stockholm",
    "timezone": "+01:00",
    "countryIndex": 213,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Singapore",
    "zone": "Asia/Singapore",
    "timezone": "+08:00",
    "countryIndex": 198,
    "dsts": "<+08>-8"
  },
  {
    "name": "Saint Helena",
    "zone": "Atlantic/St_Helena",
    "timezone": "+00:00",
    "countryIndex": 184,
    "dsts": "GMT0"
  },
  {
    "name": "Slovenia",
    "zone": "Europe/Ljubljana",
    "timezone": "+01:00",
    "countryIndex": 249,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "zone": "Arctic/Longyearbyen",
    "timezone": "+01:00",
    "countryIndex": 211,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Slovakia",
    "zone": "Europe/Bratislava",
    "timezone": "+01:00",
    "countryIndex": 200,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Sierra Leone",
    "zone": "Africa/Freetown",
    "timezone": "+00:00",
    "countryIndex": 197,
    "dsts": "GMT0"
  },
  {
    "name": "San Marino",
    "zone": "Europe/San_Marino",
    "timezone": "+01:00",
    "countryIndex": 191,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Senegal",
    "zone": "Africa/Dakar",
    "timezone": "+00:00",
    "countryIndex": 194,
    "dsts": "GMT0"
  },
  {
    "name": "Somalia",
    "zone": "Africa/Mogadishu",
    "timezone": "+03:00",
    "countryIndex": 202,
    "dsts": "EAT-3"
  },
  {
    "name": "Suriname",
    "zone": "America/Paramaribo",
    "timezone": "-03:00",
    "countryIndex": 210,
    "dsts": "<-03>3"
  },
  {
    "name": "South Sudan",
    "zone": "Africa/Juba",
    "timezone": "+02:00",
    "countryIndex": 206,
    "dsts": "CAT-2"
  },
  {
    "name": "Sao Tome and Principe",
    "zone": "Africa/Sao_Tome",
    "timezone": "+00:00",
    "countryIndex": 192,
    "dsts": "GMT0"
  },
  {
    "name": "El Salvador",
    "zone": "America/El_Salvador",
    "timezone": "-06:00",
    "countryIndex": 66,
    "dsts": "CST6"
  },
  {
    "name": "Sint Maarten",
    "zone": "America/Lower_Princes",
    "timezone": "-04:00",
    "countryIndex": 199,
    "dsts": "AST4"
  },
  {
    "name": "Syria",
    "zone": "Asia/Damascus",
    "timezone": "+03:00",
    "countryIndex": 215,
    "dsts": "<+03>-3"
  },
  {
    "name": "Swaziland",
    "zone": "Africa/Mbabane",
    "timezone": "+02:00",
    "countryIndex": 212,
    "dsts": "SAST-2"
  },
  {
    "name": "Turks and Caicos Islands",
    "zone": "America/Grand_Turk",
    "timezone": "-05:00",
    "countryIndex": 227,
    "dsts": "EST5EDT,M3.1.0,M11.1.0"
  },
  {
    "name": "Chad",
    "zone": "Africa/Ndjamena",
    "timezone": "+01:00",
    "countryIndex": 44,
    "dsts": "WAT-1"
  },
  {
    "name": "French Southern Territories",
    "zone": "Indian/Kerguelen",
    "timezone": "+05:00",
    "countryIndex": 78,
    "dsts": "<+05>-5"
  },
  {
    "name": "Togo",
    "zone": "Africa/Lome",
    "timezone": "+00:00",
    "countryIndex": 220,
    "dsts": "GMT0"
  },
  {
    "name": "Thailand",
    "zone": "Asia/Bangkok",
    "timezone": "+07:00",
    "countryIndex": 219,
    "dsts": "<+07>-7"
  },
  {
    "name": "Tajikistan",
    "zone": "Asia/Dushanbe",
    "timezone": "+05:00",
    "countryIndex": 217,
    "dsts": "<+05>-5"
  },
  {
    "name": "Tokelau",
    "zone": "Pacific/Fakaofo",
    "timezone": "+13:00",
    "countryIndex": 221,
    "dsts": "<+13>-13"
  },
  {
    "name": "East Timor",
    "zone": "Asia/Dili",
    "timezone": "+09:00",
    "countryIndex": 63,
    "dsts": "<+09>-9"
  },
  {
    "name": "Turkmenistan",
    "zone": "Asia/Ashgabat",
    "timezone": "+05:00",
    "countryIndex": 226,
    "dsts": "<+05>-5"
  },
  {
    "name": "Tunisia",
    "zone": "Africa/Tunis",
    "timezone": "+01:00",
    "countryIndex": 224,
    "dsts": "CET-1"
  },
  {
    "name": "Tonga",
    "zone": "Pacific/Tongatapu",
    "timezone": "+13:00",
    "countryIndex": 222,
    "dsts": "<+13>-13"
  },
  {
    "name": "Turkey",
    "zone": "Europe/Istanbul",
    "timezone": "+03:00",
    "countryIndex": 225,
    "dsts": "<+03>-3"
  },
  {
    "name": "Trinidad and Tobago",
    "zone": "America/Port_of_Spain",
    "timezone": "-04:00",
    "countryIndex": 223,
    "dsts": "AST4"
  },
  {
    "name": "Tuvalu",
    "zone": "Pacific/Funafuti",
    "timezone": "+12:00",
    "countryIndex": 228,
    "dsts": "<+12>-12"
  },
  {
    "name": "Taiwan",
    "zone": "Asia/Taipei",
    "timezone": "+08:00",
    "countryIndex": 216,
    "dsts": "CST-8"
  },
  {
    "name": "Tanzania",
    "zone": "Africa/Dar_es_Salaam",
    "timezone": "+03:00",
    "countryIndex": 218,
    "dsts": "EAT-3"
  },
  {
    "name": "Ukraine",
    "zone": "Europe/Kyiv",
    "timezone": "+02:00",
    "countryIndex": 231,
    "dsts": "EET-2EEST,M3.5.0/3,M10.3.0/4"
  },
  {
    "name": "Uganda",
    "zone": "Africa/Kampala",
    "timezone": "+03:00",
    "countryIndex": 230,
    "dsts": "EAT-3"
  },
  {
    "name": "United States Minor Outlying Islands",
    "zone": "Pacific/Midway",
    "timezone": "-11:00",
    "countryIndex": 235,
    "dsts": "SST11"
  },
  {
    "name": "United States Minor Outlying Islands",
    "zone": "Pacific/Wake",
    "timezone": "+12:00",
    "countryIndex": 235,
    "dsts": "<+12>-12"
  },
  {
    "name": "United States",
    "zone": "America/New_York",
    "timezone": "-05:00",
    "countryIndex": 234,
    "dsts": "EST5EDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Detroit",
    "timezone": "-05:00",
    "countryIndex": 234,
    "dsts": "EST5EDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Kentucky/Louisville",
    "timezone": "-05:00",
    "countryIndex": 234,
    "dsts": "EST5EDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Kentucky/Monticello",
    "timezone": "-05:00",
    "countryIndex": 234,
    "dsts": "EST5EDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Indiana/Indianapolis",
    "timezone": "-05:00",
    "countryIndex": 234,
    "dsts": "EST5EDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Indiana/Vincennes",
    "timezone": "-05:00",
    "countryIndex": 234,
    "dsts": "EST5EDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Indiana/Winamac",
    "timezone": "-05:00",
    "countryIndex": 234,
    "dsts": "EST5EDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Indiana/Marengo",
    "timezone": "-05:00",
    "countryIndex": 234,
    "dsts": "EST5EDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Indiana/Petersburg",
    "timezone": "-05:00",
    "countryIndex": 234,
    "dsts": "EST5EDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Indiana/Vevay",
    "timezone": "-05:00",
    "countryIndex": 234,
    "dsts": "EST5EDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Chicago",
    "timezone": "-06:00",
    "countryIndex": 234,
    "dsts": "CST6CDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Indiana/Tell_City",
    "timezone": "-06:00",
    "countryIndex": 234,
    "dsts": "CST6CDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Indiana/Knox",
    "timezone": "-06:00",
    "countryIndex": 234,
    "dsts": "CST6CDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Menominee",
    "timezone": "-06:00",
    "countryIndex": 234,
    "dsts": "CST6CDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/North_Dakota/Center",
    "timezone": "-06:00",
    "countryIndex": 234,
    "dsts": "CST6CDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/North_Dakota/New_Salem",
    "timezone": "-06:00",
    "countryIndex": 234,
    "dsts": "CST6CDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/North_Dakota/Beulah",
    "timezone": "-06:00",
    "countryIndex": 234,
    "dsts": "CST6CDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Denver",
    "timezone": "-07:00",
    "countryIndex": 234,
    "dsts": "MST7MDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Boise",
    "timezone": "-07:00",
    "countryIndex": 234,
    "dsts": "MST7MDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Phoenix",
    "timezone": "-07:00",
    "countryIndex": 234,
    "dsts": "MST7"
  },
  {
    "name": "United States",
    "zone": "America/Los_Angeles",
    "timezone": "-08:00",
    "countryIndex": 234,
    "dsts": "PST8PDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Anchorage",
    "timezone": "-09:00",
    "countryIndex": 234,
    "dsts": "AKST9AKDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Juneau",
    "timezone": "-09:00",
    "countryIndex": 234,
    "dsts": "AKST9AKDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Sitka",
    "timezone": "-09:00",
    "countryIndex": 234,
    "dsts": "AKST9AKDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Metlakatla",
    "timezone": "-09:00",
    "countryIndex": 234,
    "dsts": "AKST9AKDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Yakutat",
    "timezone": "-09:00",
    "countryIndex": 234,
    "dsts": "AKST9AKDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Nome",
    "timezone": "-09:00",
    "countryIndex": 234,
    "dsts": "AKST9AKDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "America/Adak",
    "timezone": "-10:00",
    "countryIndex": 234,
    "dsts": "HST10HDT,M3.1.0,M11.1.0"
  },
  {
    "name": "United States",
    "zone": "Pacific/Honolulu",
    "timezone": "-10:00",
    "countryIndex": 234,
    "dsts": "HST10"
  },
  {
    "name": "Uruguay",
    "zone": "America/Montevideo",
    "timezone": "-03:00",
    "countryIndex": 237,
    "dsts": "<-03>3"
  },
  {
    "name": "Uzbekistan",
    "zone": "Asia/Samarkand",
    "timezone": "+05:00",
    "countryIndex": 238,
    "dsts": "<+05>-5"
  },
  {
    "name": "Uzbekistan",
    "zone": "Asia/Tashkent",
    "timezone": "+05:00",
    "countryIndex": 238,
    "dsts": "<+05>-5"
  },
  {
    "name": "Vatican",
    "zone": "Europe/Vatican",
    "timezone": "+01:00",
    "countryIndex": 240,
    "dsts": "CET-1CEST,M3.5.0,M10.3.0/3"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "zone": "America/St_Vincent",
    "timezone": "-04:00",
    "countryIndex": 189,
    "dsts": "AST4"
  },
  {
    "name": "Venezuela",
    "zone": "America/Caracas",
    "timezone": "-04:00",
    "countryIndex": 241,
    "dsts": "<-04>4"
  },
  {
    "name": "British Virgin Islands",
    "zone": "America/Tortola",
    "timezone": "-04:00",
    "countryIndex": 33,
    "dsts": "AST4"
  },
  {
    "name": "U.S. Virgin Islands",
    "zone": "America/St_Thomas",
    "timezone": "-04:00",
    "countryIndex": 229,
    "dsts": "AST4"
  },
  {
    "name": "Vietnam",
    "zone": "Asia/Ho_Chi_Minh",
    "timezone": "+07:00",
    "countryIndex": 242,
    "dsts": "<+07>-7"
  },
  {
    "name": "Vanuatu",
    "zone": "Pacific/Efate",
    "timezone": "+11:00",
    "countryIndex": 239,
    "dsts": "<+11>-11"
  },
  {
    "name": "Wallis and Futuna",
    "zone": "Pacific/Wallis",
    "timezone": "+12:00",
    "countryIndex": 243,
    "dsts": "<+12>-12"
  },
  {
    "name": "Samoa",
    "zone": "Pacific/Apia",
    "timezone": "+13:00",
    "countryIndex": 190,
    "dsts": "<+13>-13"
  },
  {
    "name": "Yemen",
    "zone": "Asia/Aden",
    "timezone": "+03:00",
    "countryIndex": 245,
    "dsts": "<+03>-3"
  },
  {
    "name": "Mayotte",
    "zone": "Indian/Mayotte",
    "timezone": "+03:00",
    "countryIndex": 139,
    "dsts": "EAT-3"
  },
  {
    "name": "South Africa",
    "zone": "Africa/Johannesburg",
    "timezone": "+02:00",
    "countryIndex": 203,
    "dsts": "SAST-2"
  },
  {
    "name": "Zambia",
    "zone": "Africa/Lusaka",
    "timezone": "+02:00",
    "countryIndex": 246,
    "dsts": "CAT-2"
  },
  {
    "name": "Zimbabwe",
    "zone": "Africa/Harare",
    "timezone": "+02:00",
    "countryIndex": 247,
    "dsts": "CAT-2"
  },
  {
    "name": "Kosovo",
    "zone": "Europe/Prishtina",
    "timezone": "+01:00",
    "countryIndex": 248,
    "dsts": "CET-1CEST,M3.5.0/3,M10.5.0/3"
  }
]